import { useFetchData } from "@/hooks/useFetchData";
import { useMutateData } from "@/hooks/useMutateData";
import { authService } from "@/views/authentication/api/authService";

export const useLogin = (options?: any) => {
    return useMutateData({
        mutationFn: (formData: FormData) => authService.login(formData),
        ...options,
    });
};

export const useResetMyPassword = (options?: any) => {
    return useMutateData({
        mutationFn: (formData: FormData) => authService.resetMyPassword(formData),
        ...options,
    });
};

export const useGetMyProfile = (options?: any) => {
    return useFetchData({
        queryFn: () => authService.getMyProfile(),
        queryKey: ["my-profile"],
        ...options,
    });
};

export const useLogout = (options = {}) => {
    return useFetchData({
        queryFn: authService.logout,
        queryKey: ["Logout"],
        ...options,
    });
}